/**
 * Constants for BlockKit replacements
 * This file contains all the keys used for BlockKit replacements
 */

export const REPLACEMENT_KEYS = {
  // OS Settings related replacements
  OS_SETTINGS_BUTTON: 'settings_button',
  CAMERA_SETTINGS_BUTTON: 'camera_settings_button',
  MICROPHONE_SETTINGS_BUTTON: 'microphone_settings_button',
  OS_SETTINGS_LINK: 'settings_link',
  CAMERA_SETTINGS_LINK: 'camera_settings_link',
  MICROPHONE_SETTINGS_LINK: 'microphone_settings_link',
  
  // Refresh related replacements
  REFRESH_BUTTON: 'refresh_button',
  REFRESH_LINK: 'refresh_link',
} as const;

export type ReplacementKey = keyof typeof REPLACEMENT_KEYS;
export type ReplacementValue = (typeof REPLACEMENT_KEYS)[ReplacementKey];

export const SETTINGS_LINKS = {
  camera: {
    mac: 'x-apple.systempreferences:com.apple.preference.security?Privacy_Camera',
    windows: 'ms-settings:privacy-webcam'
  },
  microphone: {
    mac: 'x-apple.systempreferences:com.apple.preference.security?Privacy_Microphone',
    windows: 'ms-settings:privacy-microphone'
  }
};

/**
 * Map of all replacement keys to their values
 * This is useful for type checking and autocompletion
 */
export const REPLACEMENT_MAP: Record<ReplacementValue, ReplacementValue> = {
  [REPLACEMENT_KEYS.OS_SETTINGS_BUTTON]: REPLACEMENT_KEYS.OS_SETTINGS_BUTTON,
  [REPLACEMENT_KEYS.CAMERA_SETTINGS_BUTTON]: REPLACEMENT_KEYS.CAMERA_SETTINGS_BUTTON,
  [REPLACEMENT_KEYS.MICROPHONE_SETTINGS_BUTTON]: REPLACEMENT_KEYS.MICROPHONE_SETTINGS_BUTTON,
  [REPLACEMENT_KEYS.OS_SETTINGS_LINK]: REPLACEMENT_KEYS.OS_SETTINGS_LINK,
  [REPLACEMENT_KEYS.CAMERA_SETTINGS_LINK]: REPLACEMENT_KEYS.CAMERA_SETTINGS_LINK,
  [REPLACEMENT_KEYS.MICROPHONE_SETTINGS_LINK]: REPLACEMENT_KEYS.MICROPHONE_SETTINGS_LINK,
  [REPLACEMENT_KEYS.REFRESH_BUTTON]: REPLACEMENT_KEYS.REFRESH_BUTTON,
  [REPLACEMENT_KEYS.REFRESH_LINK]: REPLACEMENT_KEYS.REFRESH_LINK,
};
